import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaPiggyBank } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import { GoThumbsup } from "react-icons/go";
import "./Potential.css";

export default function Potential() {
  return (
    <Container className="teach-container">
      <div className="teach-title">
        <h2>Discover your potential</h2>
      </div>
      <Row className="teach-h">
        <Col lg={4}>
          <h4>
            <div className="pot-svg">
              <FaPiggyBank />
            </div>{" "}
            Earn money
          </h4>
          <p className="teach-p">
            Earn money every time a student purchases your course. Get paid
            monthly through PayPal or Payoneer, it’s your choice.
          </p>
        </Col>
        <Col lg={4}>
          <h4>
            <div className="pot-svg">
              <AiOutlineYoutube />
            </div>
            Inspire students
          </h4>
          <p className="teach-p">
            Help people learn new skills, advance their careers, and explore
            their hobbies by sharing your knowledge.
          </p>
        </Col>
        <Col lg={4}>
          <h4>
            <div className="pot-svg">
              <GoThumbsup />
            </div>
            Join our community
          </h4>
          <p className="teach-p">
            Take advantage of our active community of instructors to help you
            through your course creation process.
          </p>
        </Col>
      </Row>
    </Container>
  );
}
